<template>
  <v-text-field v-model="value"
                height="30"
                :label="$t('message.generics.message.search')"
                prepend-inner-icon="mdi-magnify"
                :hide-details="true"
                @input="(val) => emit({evt: 'input', value: val})"
                @change="(val) => emit({evt: 'change', value: val})"
                @keydown.enter.prevent="emitEnter"></v-text-field>

</template>

<script>
import EventBus from "@packages/event-bus";
import delayedSubmit from "@mixins/delayed-submit";

export default {
  data() {
    return {
      timeout: null,
      value: null,
    };
  },

  props: {
    initialVal: {
      type: String,
    },
  },

  methods: {
    emit({ evt, value }) {
      this.$emit(evt, value);

      this.delayedSubmit({ value });
    },
    setNullValue() {
      this.value = null;
    },
    emitEnter() {
      this.$emit("enter", this.value);
    },
  },

  mixins: [delayedSubmit],

  mounted() {
    this.value = this.initialVal;
    EventBus.$on("SEARCH_RESET", this.setNullValue);
  },
  beforeDestroy() {
    EventBus.$off("SEARCH_RESET", this.setNullValue);
  },
};
</script>

<style scoped>
</style>
